import { REQUEST_STATUSES } from "@/constants/index.js";
import { getNewList } from "@/utils/helper.js";

import * as types from "./types.js";

const initialState = {
  tags: [],
  status: REQUEST_STATUSES.IDLE,
  err: null,
};

export const tagsReducer = (state = {}, action) => {
  switch (action.type) {
    case types.GET_TAGS: {
      const { propertyId, tags, status, err, query } = action.payload;
      const newTags = getNewList(query, state[propertyId].tags, tags);
      return {
        ...state,
        [propertyId]: {
          tags: newTags,
          status,
          err,
          noResults: !newTags.length,
        },
      };
    }
    case types.SET_TAGS_REQUEST_STATUS: {
      const { propertyId, status } = action.payload;
      return {
        ...state,
        [propertyId]: { ...(state[propertyId] || {}), status },
      };
    }
    case types.ADD_TAG: {
      const { propertyId, tag, status, err } = action.payload;
      return {
        ...state,
        [propertyId]: { ...(state[propertyId] || {}), tags: [...state[propertyId].tags, tag], status, err },
      };
    }
    case types.UPDATE_TAG: {
      const { propertyId, tag, status, err } = action.payload;
      return {
        ...state,
        [propertyId]: {
          ...(state[propertyId] || {}),
          tags: state[propertyId].tags.map((t) => (t.id === tag.id ? tag : t)),
          status,
          err,
        },
      };
    }
    case types.RESET_TAGS: {
      const { propertyId } = action.payload;
      if (propertyId) {
        return { ...state, [propertyId]: initialState };
      }

      return {};
    }
    case types.REMOVE_TAG: {
      const { propertyId, tagId } = action.payload;
      return {
        ...state,
        [propertyId]: { ...(state[propertyId] || {}), tags: state[propertyId].tags.filter((tag) => tag.id !== tagId) },
      };
    }
    default:
      return state;
  }
};
